import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Company } from '../../../models/company.model';

interface CarbonFootprintCropStats {
  name: string;
  measuredHectares: number;
  sustainableTons: number;
}

// TODO (backend): cuando el endpoint esté listo, agregar al modelo Company (company.model.ts):
//   carbon_footprint?: { campaign: string; crops: string[] }
// El backend debe devolver este campo SOLO para empresas FARMER (productores).
// Nota: company.activity viene null en negociación y companyIs() accede a activity.id sin
// null-check, por eso se usa MOCK_DATA en lugar de companyIs(). Con el campo real del backend
// no hará falta chequear la actividad: la presencia de carbon_footprint ya lo garantiza.

@Component({
  selector: 'carbon-footprint-icon',
  templateUrl: './carbon-footprint-icon.component.html',
  styleUrls: ['./carbon-footprint-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarbonFootprintIconComponent {

  @Input() public company: Company;

  // MOCKUP: mapa hardcodeado de empresa → cultivos medidos.
  // TODO (backend): eliminar MOCK_DATA y usar company.carbon_footprint directamente.
  private readonly MOCK_DATA: { [id: number]: string[] } = {
    20: ['Soja', 'Girasol'],
    16117: ['Soja', 'Girasol'],
  };

  get hasCarbonFootprint(): boolean {
    // MOCKUP: muestra el badge solo si el ID de la empresa está en MOCK_DATA.
    // No se usa companyIs(company, 'FARMER') porque company.activity es null en negociación
    // y companyIs() accedería a activity.id sin null-check lanzando una excepción.
    // TODO (backend): reemplazar por: return !!this.company?.carbon_footprint;
    return this.company?.id in this.MOCK_DATA;
  }

  get crops(): string[] {
    // MOCKUP: cultivos según el ID de la empresa.
    // TODO (backend): reemplazar por: return this.company?.carbon_footprint?.crops ?? [];
    return this.MOCK_DATA[this.company?.id] ?? [];
  }

  get campaign(): string {
    // MOCKUP: campaña hardcodeada.
    // TODO (backend): reemplazar por: return this.company?.carbon_footprint?.campaign;
    return '25/26';
  }

  // MOCKUP: métricas por cultivo. TODO (backend): reemplazar por datos del endpoint.
  private readonly CROP_STATS: Record<string, Omit<CarbonFootprintCropStats, 'name'>> = {
    Soja: { measuredHectares: 4800, sustainableTons: 15200 },
    Girasol: { measuredHectares: 1650, sustainableTons: 3900 },
  };

  get cropStats(): CarbonFootprintCropStats[] {
    return this.crops
      .filter(name => name in this.CROP_STATS)
      .map(name => ({ name, ...this.CROP_STATS[name] }));
  }

}
